export default "__VITE_ASSET__105b5454__"